import {AfterViewInit, Component, ViewEncapsulation} from "@angular/core";
import {StateService} from "../../service/state";
import {ApiService} from "../../service/api";
import {ArticleService} from "../../service/article";
import {Meta} from "@angular/platform-browser";

declare var $: any;

@Component({
    selector: 'fw-home',
    templateUrl: './home.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        './home.scss'
    ]
})
export class HomeComponent implements AfterViewInit {
    public page: number = 1;

    constructor(private state: StateService, public apiService: ApiService, public article: ArticleService, protected meta: Meta) {
        this.loadPage(this.page);
        meta.updateTag({
            property: 'description',
            name: 'description',
            content: "Ausgefallene Windelgeschenke/Windeltorten - Der Hingucker auf jeder Babyparty oder das perfekte Mitbringsel zur Geburt und Taufe!"
        })
    }

    public loadPage(page) {
        this.page = page;

        this.article.load(page);
    }

    ngAfterViewInit() {
        this.state.setState('title', 'Übersicht');
        if(this.state.homeScroll) {
            $('fw-home .page-content').scrollTop(this.state.homeScroll);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.ts